/*
 * Automatically generated by codegen/smith.ts.
 * Do not edit this file or add other files to this directory.
 */
import { seamApiLtsVersion } from '../../../../../lib/lts-version.js';
import { getAuthHeadersForClientSessionToken, warnOnInsecureuserIdentifierKey, } from '../../../../../lib/seam/connect/auth.js';
import { createClient } from '../../../../../lib/seam/connect/client.js';
import { isSeamHttpOptionsWithApiKey, isSeamHttpOptionsWithClient, isSeamHttpOptionsWithClientSessionToken, isSeamHttpOptionsWithConsoleSessionToken, isSeamHttpOptionsWithPersonalAccessToken, SeamHttpInvalidOptionsError, } from '../../../../../lib/seam/connect/options.js';
import { limitToSeamHttpRequestOptions, parseOptions, } from '../../../../../lib/seam/connect/parse-options.js';
import { SeamHttpClientSessions } from '../../../../../lib/seam/connect/routes/client-sessions/index.js';
import { SeamHttpRequest } from '../../../../../lib/seam/connect/seam-http-request.js';
import { SeamPaginator } from '../../../../../lib/seam/connect/seam-paginator.js';
import { SeamHttpDevicesSimulate } from './simulate/index.js';
import { SeamHttpDevicesUnmanaged } from './unmanaged/index.js';
export class SeamHttpDevices {
    client;
    defaults;
    ltsVersion = seamApiLtsVersion;
    static ltsVersion = seamApiLtsVersion;
    constructor(apiKeyOrOptions = {}) {
        const options = parseOptions(apiKeyOrOptions);
        this.client = 'client' in options ? options.client : createClient(options);
        this.defaults = limitToSeamHttpRequestOptions(options);
    }
    static fromClient(client, options = {}) {
        const constructorOptions = { ...options, client };
        if (!isSeamHttpOptionsWithClient(constructorOptions)) {
            throw new SeamHttpInvalidOptionsError('Missing client');
        }
        return new SeamHttpDevices(constructorOptions);
    }
    static fromApiKey(apiKey, options = {}) {
        const constructorOptions = { ...options, apiKey };
        if (!isSeamHttpOptionsWithApiKey(constructorOptions)) {
            throw new SeamHttpInvalidOptionsError('Missing apiKey');
        }
        return new SeamHttpDevices(constructorOptions);
    }
    static fromClientSessionToken(clientSessionToken, options = {}) {
        const constructorOptions = { ...options, clientSessionToken };
        if (!isSeamHttpOptionsWithClientSessionToken(constructorOptions)) {
            throw new SeamHttpInvalidOptionsError('Missing clientSessionToken');
        }
        return new SeamHttpDevices(constructorOptions);
    }
    static async fromPublishableKey(publishableKey, userIdentifierKey, options = {}) {
        warnOnInsecureuserIdentifierKey(userIdentifierKey);
        const clientOptions = parseOptions({ ...options, publishableKey });
        if (isSeamHttpOptionsWithClient(clientOptions)) {
            throw new SeamHttpInvalidOptionsError('The client option cannot be used with SeamHttpDevices.fromPublishableKey');
        }
        const client = createClient(clientOptions);
        const clientSessions = SeamHttpClientSessions.fromClient(client);
        const { token } = await clientSessions.getOrCreate({
            user_identifier_key: userIdentifierKey,
        });
        return SeamHttpDevices.fromClientSessionToken(token, options);
    }
    static fromConsoleSessionToken(consoleSessionToken, workspaceId, options = {}) {
        const constructorOptions = { ...options, consoleSessionToken, workspaceId };
        if (!isSeamHttpOptionsWithConsoleSessionToken(constructorOptions)) {
            throw new SeamHttpInvalidOptionsError('Missing consoleSessionToken or workspaceId');
        }
        return new SeamHttpDevices(constructorOptions);
    }
    static fromPersonalAccessToken(personalAccessToken, workspaceId, options = {}) {
        const constructorOptions = { ...options, personalAccessToken, workspaceId };
        if (!isSeamHttpOptionsWithPersonalAccessToken(constructorOptions)) {
            throw new SeamHttpInvalidOptionsError('Missing personalAccessToken or workspaceId');
        }
        return new SeamHttpDevices(constructorOptions);
    }
    createPaginator(request) {
        return new SeamPaginator(this, request);
    }
    async updateClientSessionToken(clientSessionToken) {
        const { headers } = this.client.defaults;
        const authHeaders = getAuthHeadersForClientSessionToken({
            clientSessionToken,
        });
        for (const key of Object.keys(authHeaders)) {
            if (headers[key] == null) {
                throw new Error('Cannot update a clientSessionToken on a client created without a clientSessionToken');
            }
        }
        this.client.defaults.headers = { ...headers, ...authHeaders };
        const clientSessions = SeamHttpClientSessions.fromClient(this.client);
        await clientSessions.get();
    }
    get simulate() {
        return SeamHttpDevicesSimulate.fromClient(this.client, this.defaults);
    }
    get unmanaged() {
        return SeamHttpDevicesUnmanaged.fromClient(this.client, this.defaults);
    }
    delete(parameters, options = {}) {
        if (!this.defaults.isUndocumentedApiEnabled) {
            throw new Error('Cannot use undocumented API without isUndocumentedApiEnabled');
        }
        return new SeamHttpRequest(this, {
            pathname: '/devices/delete',
            method: 'POST',
            body: parameters,
            responseKey: undefined,
            options,
        });
    }
    get(parameters, options = {}) {
        return new SeamHttpRequest(this, {
            pathname: '/devices/get',
            method: 'POST',
            body: parameters,
            responseKey: 'device',
            options,
        });
    }
    list(parameters, options = {}) {
        return new SeamHttpRequest(this, {
            pathname: '/devices/list',
            method: 'POST',
            body: parameters,
            responseKey: 'devices',
            options,
        });
    }
    listDeviceProviders(parameters, options = {}) {
        return new SeamHttpRequest(this, {
            pathname: '/devices/list_device_providers',
            method: 'POST',
            body: parameters,
            responseKey: 'device_providers',
            options,
        });
    }
    update(parameters, options = {}) {
        return new SeamHttpRequest(this, {
            pathname: '/devices/update',
            method: 'PATCH',
            body: parameters,
            responseKey: undefined,
            options,
        });
    }
}
//# sourceMappingURL=devices.js.map